import { TooltipProvider } from "@shared/ui/tooltip";
import { CriticalAssetsOutOfService } from "./criticalAssetCards";
import { Anomalies } from "./anomaliesCards";
import { AlertSummaryCards } from "./alertSummaryCards";
import { HighMaintenanceCostAssets } from "./highMaintenanceAssetsCards";
import { PredictiveMaintenanceAlerts } from "./predictiveMaintenanceAlertsCards";
import { ActiveViolations } from "./activeViolationsCards";
import { OverdueInspections } from "./overdueInspectionsCards";
import { AlertTriangle } from "lucide-react";
import { useGetSystemTabDataById } from "@features/ax/assetRegistry/systems/hooks";
import { useParams } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";

export const AlertsLanding = () => {
  const { systemId } = useParams();
  const { data: alertsData } = useGetSystemTabDataById(
    Number(systemId),
    "alerts"
  );
  useEffect(() => {
    logEvent("alerts_tab_viewed");
  }, []);

  return (
    <TooltipProvider>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
            <AlertTriangle className="h-5 w-5 text-indigo-600" />
          </div>
          <div>
            <PageHeader
              title="Active Alerts"
              subtitle="Critical events, potential failures, and compliance issues requiring immediate attention"
            />
          </div>
        </div>

        {/* Summary Alert Cards */}
        <AlertSummaryCards data={alertsData} />

        {/* Critical Operational Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CriticalAssetsOutOfService data={alertsData} />
          <Anomalies data={alertsData} />
        </div>

        {/* Performance & Predictive Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <HighMaintenanceCostAssets data={alertsData} />
          <PredictiveMaintenanceAlerts data={alertsData} />
        </div>

        {/* Compliance & Risk Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ActiveViolations data={alertsData} />
          <OverdueInspections data={alertsData} />
        </div>
      </div>
    </TooltipProvider>
  );
};
